import { listDaysBetweenTwoDates, listMonthsBetweenTwoDates } from './convert-dates';

export const listDatesBetweenTwoDates = (startDate: string, endDate: string, isDayEntitlement: boolean) => {
  return isDayEntitlement ? listDaysBetweenTwoDates(startDate, endDate) : listMonthsBetweenTwoDates(startDate, endDate);
};

export const getPickedMissingDates = ({
  isDayEntitlement,
  missingMonths,
  missingDays,
  startDate,
  endDate,
}: {
  isDayEntitlement: boolean;
  missingMonths: string[];
  missingDays: string[];
  startDate: string;
  endDate: string;
}) => {
  const missingDates = isDayEntitlement ? missingDays : missingMonths;
  const datesList = listDatesBetweenTwoDates(startDate, endDate, isDayEntitlement);
  return {
    chunks: datesList.filter((date) => missingDates.includes(date)),
    chunkType: isDayEntitlement ? 'days' : 'months',
  };
};
